/**
 * The external dependencies.
 */
import React from 'react';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';
import 'react-id-swiper/src/styles/css/swiper.css';
/**
 * The internal dependencies.
 */
import PhotoPlaceholder from '../../../../assets/images/temp/photo-placeholder.png';

const SliderWrapper = styled.div`
	width: 164px;
`;

const PhotoWrapper = styled.a`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 163px;
`;

const Dots = styled.ul`
	display: flex;
	justify-content: center;
	list-style: none outside;
`;

const Dot = styled.li`
	font-size: 63px;
	line-height: .4;
	color: ${({active}) => active ? '#44aaf3' : '#e5e8ea'};

	& li {
		margin-left: 10px;
	}
`;

class Camera extends React.Component {
    constructor() {
        super();

        this.state = {
            currentSlide: 0,
        };
    }

    handlePhotoClick = () => {
        const {camera} = navigator;

        if (!camera) {
            return alert('No Camera Option has been found')
        }

        const currentIndex = this.swiper.activeIndex;

        camera.getPicture(
            (imageData) => this.props.handleChange(currentIndex, imageData),
            this.handleFail,
            {
                quality: 50,
                destinationType: camera.DestinationType.DATA_URL,
                encodingType: camera.EncodingType.PNG,
            }
        );
    };

    handleFail(message) {
        alert('Failed because: ' + message);
    }

    updateCurrentSlide = () => {
        if (!this.swiper) {
            return;
        }

        this.setState({currentSlide: this.swiper.activeIndex})
    };

    render() {
        const {photos, handleChange} = this.props;
        const {currentSlide} = this.state;

        if (!photos.length) {
            return;
        }

        const params = {
            on: {
                slideChange: this.updateCurrentSlide
            }
        };

        return (
            <SliderWrapper>
                <Swiper {...params} ref={node => node ? this.swiper = node.swiper : null}>
                    {photos.map((photo, index) => (
                        <PhotoWrapper
                            key={`photo-item-${index}`}
                            onClick={handleChange ? this.handlePhotoClick : null}
                        >
                            <img src={photo ? photo : PhotoPlaceholder}/>
                        </PhotoWrapper>
                    ))}
                </Swiper>

                <Dots>
                    {photos.map((image, index) => (
                        <Dot key={`photo-nav-item-${index}`} active={index === currentSlide}>•</Dot>
                    ))}
                </Dots>
            </SliderWrapper>
        );
    }
}

export default Camera;



// WEBPACK FOOTER //
// ./src/components/task/working/report/camera.js